<template>
  <!-- <b-modal id="registerModal" ref="registerModal" centered hide-footer hide-header size="xl" style="position: relative">
    <div class="topRightCross" @click="hideModal()"></div>
    <register-lasso />
  </b-modal> -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" centered hide-footer hide-header size="xl" style="position: relative">
  <div ref="registerModal" class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" @click="hideModal()">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div  class="modal-body">
        <register-lasso />
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </div>
  </div>
</div>
</template>

<script>
// import Register from '~/components/Register.vue';
import RegisterLasso from "~/components/RegisterLasso.vue";

export default {
  components: {
    // Register,
    RegisterLasso,
  },
  data() {
    return {
      form: {
        email: "",
        firstname: "",
        lastname: "",
        phone: "",
        cellphone: "",
        homephone: "",
        city: "",
        postalcode: "",
        methodOfContact: null,
        howdidyouhearaboutus: null,
        agent: null,
        agentname: null,
      },
    };
  },
  methods: {
    hideModal() {
      this.$refs.registerModal.hide();
    },
  },
};
</script>

<style>
.col-form-label {
  padding-left: 7px;
  font-size: 14px;
}
</style>
